import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
/** ========== */

const RefundGuarantee = ({ ...props }) => {
  return (
    <div {...props}>
      <div className="flex flex-col items-center justify-center text-center lg:flex-row lg:text-left">
        <Img src="/assets/icons/refund-guarantee.svg" width={80} height={80} />
        <div className="mt-4 lg:mt-0 lg:ml-4">
          <p className="text-lg font-semibold">Refund Guarantee</p>
          <p className="text-base font-normal">
            We refund your money in full for services that we cannot deliver.
          </p>
          <em className="text-sm font-medium leading-6 text-bbc-brand-500 underline">
            <Link href="/refund-policy" target={"_blank"}>
              Read our policy
            </Link>
          </em>
        </div>
      </div>
    </div>
  );
};

export default RefundGuarantee;

/** ========== */
